import SelectWithFetch from './SelectWithFetch';
import getValues from '../../api/services/getValues';

const SelectServices = (props) => {
  return <SelectWithFetch fetch={getValues} {...props} />;
};

export default SelectServices;
